import { IEmbed } from "../../../embedsV2/interface";

export const parseSettings = (embed: IEmbed) => {
  let settings;
  if (typeof embed?.settings === "object" && embed?.settings !== null) {
    settings = {};
  } else {
    settings = JSON.parse(embed.settings);
  }
  return settings;
};
